import { useVirtualizer } from '@tanstack/react-virtual';
import { HTMLAttributes, ReactNode, useRef } from 'react';

type VirtualizedYContainerProps = HTMLAttributes<HTMLElement>;

export const VirtualizedYContainer = ({
  children,
  ...rest
}: VirtualizedYContainerProps) => {
  const listBoxRef = useRef(null);

  /* oxlint-disable react-hooks-js/incompatible-library */
  // eslint-disable-next-line react-hooks/incompatible-library
  const rowVirtualizer = useVirtualizer({
    getScrollElement: () => listBoxRef.current,
    count: (children as ReactNode[]).length,
    estimateSize: () => 40,
    overscan: 5,
  });
  /* oxlint-enable react-hooks-js/incompatible-library */

  const virtualRows = rowVirtualizer.getVirtualItems();

  const virtualIndexes = {
    start: virtualRows[0]?.index || 0,
    end: virtualRows.at(-1)?.index || 0,
  };
  const actualChildren = (children as ReactNode[]).slice(
    virtualIndexes.start,
    virtualIndexes.end ? virtualIndexes.end + 1 : undefined,
  );

  const paddingTop = virtualRows.length > 0 ? virtualRows?.[0]?.start || 0 : 0;
  const paddingBottom =
    virtualRows.length > 0
      ? rowVirtualizer.getTotalSize() - (virtualRows.at(-1)?.end || 0)
      : 0;

  return (
    <div ref={listBoxRef} {...rest}>
      {paddingTop > 0 && <div style={{ height: `${paddingTop}px` }} />}
      {actualChildren}
      {paddingBottom > 0 && <div style={{ height: `${paddingBottom}px` }} />}
    </div>
  );
};
